import { INITIALIZE_FORM } from '../actionTypes';
import { templatesActions } from '../reducer';

import setIsOpenModal from './setIsOpenModal';

export default (type) => (dispatch) => {
    dispatch(templatesActions[INITIALIZE_FORM]({ type }));
    dispatch(setIsOpenModal(true));
};
